module.exports = __webpack_public_path__ + "static/equipment-content-1-a1ff454c7dd9f4cf9610c8a2b0f3f8a1.png";